import { z } from "zod";
import { ruoloSchema } from "./common.js";
export const loginRequestSchema = z.object({
    username: z.string().min(1).max(64),
    password: z.string().min(1),
    totp_code: z.string().length(6).optional(),
});
export const loginResponseSchema = z.object({
    utente: z.object({
        id: z.string().uuid(),
        username: z.string(),
        nome: z.string(),
        cognome: z.string(),
        ruolo: ruoloSchema,
        must_change_password: z.boolean(),
        mfa_enabled: z.boolean(),
    }),
    require_totp: z.boolean().optional(),
});
export const mobileLoginResponseSchema = z.object({
    access_token: z.string(),
    expires_in: z.number(),
    refresh_token: z.string(),
    utente: z.object({
        id: z.string().uuid(),
        username: z.string(),
        nome: z.string(),
        cognome: z.string(),
        ruolo: ruoloSchema,
        must_change_password: z.boolean(),
    }),
});
export const refreshTokenRequestSchema = z.object({
    refresh_token: z.string(),
    device_id: z.string().max(64),
});
export const changePasswordRequestSchema = z
    .object({
    current_password: z.string().min(1),
    new_password: z.string().min(12).max(128),
    new_password_confirm: z.string(),
})
    .refine((d) => d.new_password === d.new_password_confirm, {
    message: "Le password non coincidono",
    path: ["new_password_confirm"],
});
export const resetPasswordRequestSchema = z.object({
    email: z.string().email(),
});
export const resetPasswordConfirmSchema = z
    .object({
    token: z.string(),
    new_password: z.string().min(12).max(128),
    new_password_confirm: z.string(),
})
    .refine((d) => d.new_password === d.new_password_confirm, {
    message: "Le password non coincidono",
    path: ["new_password_confirm"],
});
export const setupTotpResponseSchema = z.object({
    secret: z.string(),
    qr_url: z.string(),
    backup_codes: z.array(z.string()),
});
export const confirmTotpSchema = z.object({
    totp_code: z.string().length(6),
});
export const verifyOtpRequestSchema = z.object({
    challenge_token: z.string().min(1),
    code: z.string().length(6),
});
//# sourceMappingURL=auth.js.map